export const VIEW = {
  INTRO: 'intro',
  PREDICTION: 'prediction',
  ERROR: 'error',
} as const;

export type ViewType = typeof VIEW[keyof typeof VIEW];
